@if (showImage()) {
  <img
    [src]="imageUrl()"
    [alt]="name()"
    class="rounded-full object-cover"
    [ngClass]="sizeClass()"
    (error)="onImageError()"
  />
} @else {
  <div
    class="inline-flex shrink-0 items-center justify-center rounded-full bg-gray-100 text-gray-500"
    [ngClass]="sizeClass()"
  >
    <span class="font-semibold uppercase" [ngClass]="textClass()">
      {{ name() | initials }}
    </span>
  </div>
}
